import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PaymentsTabsService {
  activeTab = signal<string>('');
  activeTabIndex = signal<number>(0);

  setActiveTab(route: string, index: number): void {
    this.activeTab.set(route);
    this.activeTabIndex.set(index);
  }

  reset(): void {
    this.activeTab.set('');
    this.activeTabIndex.set(0);
  }
}
